import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class bomModuleParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    mainTitle: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'mainTitle', 'BOM'),
    },
    bom_add: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'add_material', 'Added Materials'),
    },
    bomDetails: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'bomDetails', 'BOM Details'),
    },
    generate: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'generate', 'Generate'),
    },
    basicDetails: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'basicDetail', 'Basic Details'),
    },
    materialDetails: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'materialDetails', 'Material Details'),
    },
    material: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'material', 'Material'),
    },
    product_name: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'product_name', 'Material Name'),
    },
    price: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'price', 'Price'),
    },
    total: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'total', 'Total'),
    },
    grade: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'grade', 'Grade'),
    },
    type_property: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'type_property', 'Type Property'),
    },
    filler: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'filler', 'Filler'),
    },
    total_cost: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'total_cost', 'Total Cost'),
      isVisible: this.moduleParamConfigGlob.isVisible('bom', 'total_cost'),
    },
    physical_property: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'physical_property', 'Physical Property'),
    },
    size: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'size', 'Size'),
    },
    material_qty: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'material_qty', 'Material Qty'),
    },
    uom: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'uom', 'UOM'),
    },
    color: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'color', 'Color'),
    },
    product_code: {
      label: this.moduleParamConfigGlob.getLabel('bom', 'product_code', 'Product Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('bom', 'product_code'),
    },
  };

  materialDetails = {
    material: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'material', 'Material'),
    },
    grade: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'grade', 'Grade'),
    },
    filler: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'filler', 'Filler'),
    },
    weight: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'weight', 'Weight'),
    },
    size: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'size', 'Size'),
    },
    color: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'color', 'Color'),
    },
    total_amount: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'totalAmount', 'Total Amount'),
    },
    material_price: {
      label: this.moduleParamConfigGlob.getLabel('bomMaterialDetails', 'material_price', 'Material Price (per qty)'),
    },
  };

  qualityParameterDetails = {
    quality_parameters_details: {
      label: this.moduleParamConfigGlob.getLabel(
        'bomQualityParametersDetails',
        'quality_parameters_details',
        'Quality Parameters Details'
      ),
    },
    parameter: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'parameter', 'Quality Parameter'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'parameter'),
    },
    parameterDetails: {
      label: this.moduleParamConfigGlob.getLabel(
        'bomQualityParametersDetails',
        'parameterDetails',
        'Parameter Details'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'parameterDetails'),
    },
    name: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'name', 'Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'name'),
    },
    value: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'value', 'Value'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'value'),
    },
    range_starts: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'range_starts', 'Range Starts'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'range_starts'),
    },
    range_ends: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'range_ends', 'Range Ends'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'range_ends'),
    },
    parameter_type: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'parameter_type', 'Type'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'parameter_type'),
    },
    tolerance: {
      label: this.moduleParamConfigGlob.getLabel('bomQualityParametersDetails', 'tolerance', 'Tolerance'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomQualityParametersDetails', 'tolerance'),
    },
  };

  costHeadDetails = {
    cost_head: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'cost_head ', 'Cost Head Details'),
    },
    name: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'name', 'Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomCostHeadDetails', 'name'),
    },
    amount: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'amount', 'Amount'),
      isVisible: this.moduleParamConfigGlob.isVisible('bom', 'amount'),
    },
    units: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'units', 'Units'),
    },
    per_unit_cost: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'per_unit_cost', 'Per Unit Cost'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomCostHeadDetails', 'per_unit_cost'),
    },
    total: {
      label: this.moduleParamConfigGlob.getLabel('bomCostHeadDetails', 'total', 'Total'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomCostHeadDetails', 'total'),
    },
  };

  documentDetails = {
    documentTitle: {
      label: this.moduleParamConfigGlob.getLabel('bomDocumentDetails', 'documentTitle', 'Document Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomDocumentDetails', 'documentTitle'),
    },
    file_name: {
      label: this.moduleParamConfigGlob.getLabel('bomDocumentDetails', 'file_name', 'File Name'),
    },
    file: {
      label: this.moduleParamConfigGlob.getLabel('bomDocumentDetails', 'file', 'File'),
    },
    upload: {
      label: this.moduleParamConfigGlob.getLabel('bomDocumentDetails', 'upload', 'Document Upload'),
      isVisible: this.moduleParamConfigGlob.isVisible('bomDocumentDetails', 'upload'),
    },
  };
}
